<template>
    <div class="profile-card">
        <div class="profile-card-header">{{ card.title }}</div>
        <div class="profile-card-body">
            <!-- field content wiring -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        card: { type: Object, required: true },
        psp: { type: String, required: true },
        recordId: { type: [Number, String], required: true },
    }
};
</script>
